<template>
  <div
    class="welcome-parchment mt-md-5 windows-command-prompt"
    :class="noPaddingTop ? '' : 'm-md-4'"
  >
    <div class="d-flex flex-row justify-content-center">
      <span class="welcome-text upheavel-pro">Welcome</span>
    </div>
    <div class="d-flex flex-row justify-content-start nft-image-text">
      <div class="welcome-chicken-image">
        <img class="welcome-chicken" src="../assets/images/davik.webp" alt="" />
      </div>
      <div class="welcome-chicken-text">
        <span class="nft-information-text"
          >These hard-working entities are the most common characters in the
          game. But they bring in the most important element: They can produce
          1000 $EGGS/day.</span
        >
      </div>
    </div>
    <div class="d-flex flex-row justify-content-start nft-image-text">
      <div class="welcome-snake-text">
        <span class="nft-information-text"
          >These bandits have one purpose, and it's to steal $EGGS and freshly
          minted chickens (or snakes?). They also have a venom rank system
          amongst theirselves to share their loot.</span
        >
      </div>
      <div class="welcome-snake-image">
        <img
          class="welcome-snake"
          src="../assets/images/snkbasic.webp"
          alt=""
        />
      </div>
    </div>
    <div class="d-flex flex-row justify-content-start nft-image-text">
      <div class="welcome-rooster-image">
        <img
          class="welcome-rooster"
          src="../assets/images/rooster-3.webp"
          alt=""
        />
      </div>
      <div class="welcome-rooster-text">
        <span class="nft-information-text"
          >These guardians are there to protect newly minted nft’s at all costs.
          They can guarantee 5/6 protection against snakes kidnapping newly
          minted chickens (or snakes?). They make a with their living out of
          commissions.</span
        >
      </div>
    </div>
    <div class="d-flex flex-row justify-content-center currency-information">
      <span class="upheavel-pro currency-information-text"
        >currency information</span
      >
    </div>
    <div
      class="
        d-flex
        flex-row
        justify-content-center
        currency-information
        text-center
      "
    >
      <div class="currency-information-inside">
        <span class="nft-information-text">
          The precious utility token of the Eggs Game eggconomy, the currency of
          the traders. $EGGS is the scarce token of all the transactions in this
          metaverse.</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noPaddingTop: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style scoped>
.welcome-parchment {
  background-image: url("../assets/images/welcome-parchment-new.webp");
  background-repeat: no-repeat;
  background-size: 605px 793px;
  width: 605px;
  height: 793px;
}
.welcome-text {
  color: #000000;
  font-size: 99.5px;
  line-height: 99.5px;
  margin-top: 25px;
}
.nft-image-text {
  margin: 0 0 0 33px;
}
.nft-information-text {
  color: #000000 !important;
  font-size: 18.5px !important;
  margin-top: 0px;
  width: 100%;
}
.welcome-chicken-text {
  width: 420px;
  text-align: left;
  margin-top: 30px;
  margin-left: 10px;
  line-height: 23px;
}
.welcome-snake-image {
  margin: 25px 33px 0 7px;
}
.welcome-snake-text {
  width: 420px;
  line-height: 23px;
  margin: 40px 0 0 0px;
}
.welcome-snake {
  width: 121px;
  height: 122px;
}
.welcome-rooster {
  width: 109px;
  height: 125px;
}
.welcome-rooster-image {
  margin: 20px 5px 0 0;
}
.welcome-rooster-text {
  width: 430px;
  margin: 25px 0 0 0;
  line-height: 23px;
}
.currency-information {
  margin-top: 0px;
  text-align: center;
}
.currency-information-text {
  color: #000 !important;
  font-size: 36px !important;
  margin-top: 10px;
  line-height: 30px;
  width: 85%;
  margin-left: 10px;
  text-align: center;
}
.currency-information-inside {
  width: 414px;
  line-height: 23px;
  text-align: center;
  margin-top: 20px;
}
@media (max-width: 1300px) {
  .welcome-chicken-text {
    width: 250px;
    line-height: normal;
    margin-top: 30px;
    text-align: left;
  }
  .welcome-chicken-image {
    margin-top: 20px;
  }
  .welcome-snake-image {
    margin-top: 10px;
  }
  .welcome-snake-text {
    line-height: 15px;
    margin-top: 10px;
  }
  .welcome-rooster-text {
    line-height: 15px;
    width: 260px;
    margin-top: 20px;
  }
  .welcome-chicken {
    width: 48px;
    height: 68px;
  }
  .welcome-snake {
    width: 61px;
    height: 60px;
  }
  .welcome-rooster {
    width: 57.3px;
    height: 68px;
  }
  .welcome-parchment {
    background-size: 400px 550px;
    width: 400px;
    height: 550px;
  }
  .welcome-text {
    color: #000000;
    font-size: 50px;
    line-height: normal;
  }
  .nft-image-text {
    margin: 15px 0 0 44px;
  }
  .nft-information-text {
    color: black !important;
    font-size: 13px !important;
  }
  .currency-information {
    margin-top: 0;
  }
  .currency-information-text {
    color: #2a2a2a !important;
    font-size: 25px !important;
  }
  .currency-information-inside {
    width: 250px;
    line-height: 15px;
  }
}
@media (max-width: 780px) {
  .welcome-chicken-text {
    width: 270px;
    line-height: 10px;
    margin-top: 5px;
    text-align: left;
  }
  .welcome-snake-image {
    margin-top: 10px;
  }
  .welcome-snake-text {
    line-height: 10px;
    margin: 15px 0 0 0;
    width: 220px;
  }
  .welcome-chicken-image {
    margin-top: -10px;
  }
  .welcome-rooster-text {
    line-height: 8px;
    width: 180px;
    margin-top: 10px;
  }
  .welcome-snake-image {
    margin-top: 0px;
    margin-right: 20px;
  }
  .welcome-chicken {
    width: 48px;
    height: 68px;
  }
  .welcome-chicken-text {
    width: 190px;
  }
  .welcome-snake {
    width: 61px;
    height: 60px;
  }
  .welcome-rooster {
    width: 57.3px;
    height: 68px;
  }
  .welcome-rooster-image {
    margin: 5px 10px 0 0;
  }
  .welcome-parchment {
    background-size: 298px 410px;
    width: 298px;
    height: 410px;
  }
  .welcome-text {
    color: #000000;
    font-size: 50px;
  }
  .nft-image-text {
    margin: 5px 0 0 25px;
  }
  .nft-information-text {
    color: black !important;
    font-size: 10px !important;
    line-height: 5px;
  }
  .currency-information {
    margin-top: 0;
  }
  .currency-information-text {
    color: #2a2a2a !important;
    font-size: 15px !important;
    margin: 0;
  }
  .currency-information-inside {
    width: 250px;
    line-height: 10px;
  }
  @supports (-webkit-touch-callout: none) {
    .welcome-text{
        line-height: normal;
        margin-bottom: 20px;
    }
  }
}
</style>